import { version } from '../../package.json';

export const VersionInfo = () => {
  return (
    <div className="text-xs text-gray-400">
      <span>Desarrollado por </span>
      <a 
        href="https://neurasur.com/" 
        title="NeuraSur" 
        target="_blank" 
        rel="noopener noreferrer"
        className="text-amber-500 hover:text-amber-400 transition-colors"
      >
        NeuraSur
      </a>
      <span className="ml-2">v{version}</span>
    </div>
  );
};